export enum RodzajPodmiotu {
  INSTYTUCJA_PUBLICZNA = 0,
  GMINA = 1,
  POWIAT = 2,
  WOJEWODZTWO = 3,
  OSOBA_FIZYCZNA = 4,
  OSOBA_PRAWNA = 5,
  JEDNOSTKA_NIEPOSIADAJACA_OSOBOWOSCI_PRAWNEJ = 6,
  OSOBA_FIZYCZNA_BEZ_DZIALALNOSCI_GOSP = 7,
}

export const RODZAJ_PODMIOTU_LABELS: Record<RodzajPodmiotu, string> = {
  [RodzajPodmiotu.INSTYTUCJA_PUBLICZNA]: 'Instytucja publiczna',
  [RodzajPodmiotu.GMINA]: 'Gmina',
  [RodzajPodmiotu.POWIAT]: 'Powiat',
  [RodzajPodmiotu.WOJEWODZTWO]: 'Województwo',
  [RodzajPodmiotu.OSOBA_FIZYCZNA]: 'Osoba fizyczna',
  [RodzajPodmiotu.OSOBA_PRAWNA]: 'Osoba prawna',
  [RodzajPodmiotu.JEDNOSTKA_NIEPOSIADAJACA_OSOBOWOSCI_PRAWNEJ]:
    'Jednostka nieposiadająca osobowości prawnej',
  [RodzajPodmiotu.OSOBA_FIZYCZNA_BEZ_DZIALALNOSCI_GOSP]:
    'Osoba fizyczna bez działalności gospodarczej',
};
